import config from '@/config';
import { getRegion } from '@/utilities/getters/cookieGetters';

export const getMDSEndpoint = () => {
  return config?.mdsEndpoint?.[getRegion().toUpperCase()] || '';
};
